import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import PopularKeywordList from "../../components/PopularKeywords";

const PopularKeywordPage = (): ReactElement => {
  return (
    <Layout>
      <PopularKeywordList />
    </Layout>
  );
};

export default PopularKeywordPage;
